import type { InvertedLocalize } from '../../../../utils/localization';
import type { FilterPill } from '../FilterPills';
import type { EntitlementRow } from '../IncludedEntitlements';
import type { IncludedEntitlementsMessage } from '../messages';

// Type for localization function
type LocalizeFn = InvertedLocalize<IncludedEntitlementsMessage>;

/**
 * Generate filter pills from EntitlementRow[] (excludes deleted entitlements)
 */
// eslint-disable-next-line import/prefer-default-export
export const generateFilterPillsFromEntitlementRows = (
  entitlementRows: EntitlementRow[],
  l: LocalizeFn
): FilterPill[] => {
  const applications = new Set<string>();
  const entitlementOptions: { label: string; value: string }[] = [];

  entitlementRows.forEach((row) => {
    // Applications filter
    const applicationName = row.endpointDisplayName ?? row.endpointName;

    applications.add(applicationName);

    // Entitlements filter - use evKey as value for consistency with filtering logic
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- in case it's empty string
    const entitlementName = row.evDisplayName || row.entitlementValueName;

    entitlementOptions.push({
      label: entitlementName,
      value: String(row.evKey),
    });
  });

  return [
    {
      id: 'applications',
      label: l('Applications'),
      options: Array.from(applications).map((app) => ({
        label: app,
        value: app,
      })),
    },
    {
      id: 'entitlements',
      label: l('Entitlements'),
      options: entitlementOptions,
    },
    {
      id: 'access_status',
      label: l('Access Status'),
      options: [
        { label: l('Present'), value: 'present' },
        { label: l('Absent'), value: 'absent' },
      ],
    },
  ];
};
